import { gql } from '../__generated__';

export const PERFORM_CHECK_IN = gql(`
  mutation PerformCheckIn($accessGrantId: String!) {
    performCheckIn(accessGrantId: $accessGrantId) {
      success
    }
  }
`);
